<template>
  <div class="d-none d-md-flex flex-column align-items-end">
    <div class="btn-group-vertical">
      <a v-if="showButton" :class="buttonClass" @click.stop="$emit('connect')">
        <IneaIcone
          name="dgfipicon-cadenas-ferme"
          class="dgfipicon dgfipicon-xs me-1_2"
          :color="iconColor"
        />
        {{ text }}
      </a>
    </div>
  </div>
</template>

<script>
import IneaIcone from "@clir/IneaIcone/IneaIcone";
export default {
  name: "BlocPriveDisconnected",
  props: {
    connectConfig: { type: Object, default: () => {} }
  },
  computed: {
    buttonClass() {
      return `${this.prefixStringKey(this.connectConfig, "buttonClass", {
        prefix: "btn text-truncate text-start ",
        defaut: "btn text-truncate text-start"
      })} ${this.prefixStringKey(this.connectConfig, "buttonColor", {
        prefix: "btn-",
        defaut: "btn-primary"
      })}`;
    },
    iconColor() {
      return this.getKey(this.connectConfig, "iconColor", "");
    },
    text() {
      return this.getKey(this.connectConfig, "text", "Connectez-vous");
    },
    showButton() {
      return this.connectConfig.show;
    }
  },
  components: {
    IneaIcone
  }
};
</script>